import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ReplaySubject } from 'rxjs';
import { take, map, tap } from 'rxjs/operators';
import { parseQueryPqrams, removeUrlQueryParam } from 'src/app/util';
import { GeneratorEnv } from '../../web-generator/generator-env-token';
import { CSP_NONCE_KEY } from '../tokens/csp-nonce.statekey';
import * as i0 from "@angular/core";
import * as i1 from "@nguniversal/express-engine/tokens";
import * as i2 from "@angular/platform-browser";
import * as i3 from "./common-http-client.service";
import * as i4 from "./logger.service";
import * as i5 from "@angular/common";
import * as i6 from "../../web-generator/generator-env-token";
export class ServerConfigService {
    constructor(platformId, request, tState, http, loggerService, document, generatorEnv) {
        this.platformId = platformId;
        this.request = request;
        this.tState = tState;
        this.http = http;
        this.loggerService = loggerService;
        this.document = document;
        this.generatorEnv = generatorEnv;
        /** 是否為 SSR 模式 */
        this.isSSRMode = false;
        /** 網站 basehref */
        this.baseHref = '/';
        /** 網站基礎設定 */
        this._config$ = new ReplaySubject();
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.isServer = isPlatformServer(this.platformId);
        this.isSSRMode = this.isServer || this.tState.hasKey(CSP_NONCE_KEY);
        if (!this.isBrowser) {
            this.loggerService.info(`isBrowser: ${this.isBrowser}; isServer: ${this.isServer}; isSSRMode: ${this.isSSRMode}`);
        }
        const baseHref = this.document.head.getElementsByTagName('base')[0].getAttribute('href');
        if (baseHref.endsWith('/')) {
            this.baseHref = baseHref.slice(0, baseHref.length - 1);
        }
        else {
            this.baseHref = baseHref;
        }
        if (this.isBrowser) {
            this.url = location.href.replace('/?', '?').replace(/\/$/g, '');
            this.pathname = removeUrlQueryParam(location.pathname).replace(/\/$/g, '');
            // const queryParam = location.search.slice(1, location.search.length);
            this.queryParams = parseQueryPqrams(this.url);
            this.origin = location.origin;
            window['printAllState'] = () => {
                this.tState.toJson();
            };
        }
        else {
            this.url = `${this.request.protocol}://${this.request.get('host')}${this.request.originalUrl}`.replace('/?', '?').replace(/\/$/g, '');
            this.loggerService.info(`url: ${this.url}`);
            this.pathname = removeUrlQueryParam(this.request._parsedUrl.pathname).replace(/\/$/g, '');
            this.loggerService.info(`pathname: ${this.pathname}`);
            // const queryParam = this.request._parsedUrl.query;
            this.queryParams = parseQueryPqrams(this.url);
            this.loggerService.info(`queryParams: `, this.queryParams);
            this.origin = `${this.request.protocol}://${this.request.get('host')}`;
        }
        const urlSegArr = this.pathname.split('/');
        const lang = urlSegArr[1];
        this.lang = lang;
        this.isEditModeUrl = !!this.queryParams['stage'];
        if (!this.isBrowser) {
            this.loggerService.info(`isEditModeUrl: ${this.isEditModeUrl}`);
        }
    }
    /** 網站基本設定(唯讀) */
    get config() { return this._config; }
    /** 載入網站基本資料 */
    loadConfig$() {
        // timer(500).pipe(
        //   map(t => siteInfoTestData),
        this.http.get(`${this.generatorEnv.apiHost}/api/site/${this.lang}`).pipe(map(info => JSON.parse(JSON.stringify(info))), // 克隆一份為了修正menu的循環引用導致transferState儲存失敗，將transferState裡的物件和實際畫面上使用的資料分開
        tap(info => {
            this._config = info;
        })).subscribe(config => this._config$.next(config));
        return this.getConfig$();
    }
    getConfig$() {
        return this._config$.pipe(take(1), map(config => JSON.parse(JSON.stringify(config))));
    }
    getCurrentUrl() {
        if (this.isServer) {
            return this.url;
        }
        else {
            return location.href;
        }
    }
    getCurrentPathname() {
        if (this.isServer) {
            return this.pathname;
        }
        else {
            return location.pathname;
        }
    }
    getCurrentQueryParams() {
        if (this.isServer) {
            return this.queryParams;
        }
        else {
            const queryParamStr = location.search.slice(1, location.search.length);
            const queryParams = queryParamStr ? parseQueryPqrams(queryParamStr) : {};
            return queryParams;
        }
    }
}
ServerConfigService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ServerConfigService_Factory() { return new ServerConfigService(i0.ɵɵinject(i0.PLATFORM_ID), i0.ɵɵinject(i1.REQUEST, 8), i0.ɵɵinject(i2.TransferState, 8), i0.ɵɵinject(i3.CommonHttpClientService), i0.ɵɵinject(i4.LoggerService), i0.ɵɵinject(i5.DOCUMENT), i0.ɵɵinject(i6.GENERATOR_ENV_TOKEN)); }, token: ServerConfigService, providedIn: "root" });
